/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";

import { useSoftUIController } from "context";
import moment from 'moment';

// Soft UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MiniStatisticsCard from "examples/MiniStatisticsCard";

// Dashboard layout components
import DriverDetail from "layouts/drivers/components/DriverDetail";

function Drivers() {
  const [controller, dispatch] = useSoftUIController();
  const { drivers, deliveries, pickups, selectedDriver, currentDate } = controller;

  let statDeliveries = selectedDriver ? deliveries.filter(d => d.driver === selectedDriver.email) : deliveries;
  let statPickups = selectedDriver ? pickups.filter(p => p.driver === selectedDriver.email) : pickups;

  let completedDeliveries = statDeliveries.filter(d => d.completed);
  let completedPickups = statPickups.filter(p => p.completed);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6}>
              <MiniStatisticsCard
                title={{ text: currentDate ? `Deliveries (Complete/Total) for ${currentDate.format("MMM Do, YYYY")}` : " Deliveries (Complete/Total)" }}
                count={`${completedDeliveries.length}/${statDeliveries.length}`}
                icon={{ color: "info", component: "directions_bus" }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MiniStatisticsCard
                title={{ text: currentDate ? `Pickups (Complete/Total) for ${currentDate.format("MMM Do, YYYY")}` : " Pickups (Complete/Total)" }}
                count={`${completedPickups.length}/${statPickups.length}`}
                icon={{ color: "info", component: "view_in_ar" }}
              />
            </Grid>          
          </Grid>
        </SoftBox>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <DriverDetail drivers={drivers} deliveries={deliveries} pickups={pickups} selectedDriver={selectedDriver} />
            </Grid>
          </Grid>
        </SoftBox>              
      </SoftBox>
    </DashboardLayout>
  );
}

export default Drivers;
